export default __webpack_public_path__ + "static/media/logo-lg-1440w.314fc873.webp";